import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { injectIntl } from 'react-intl'
import { inlineLexer } from 'marked'
import { findLocalized } from '../utils'


const Evento = ({ intl: { locale } }) => (
  <StaticQuery
    query={graphql`
      query {
        hero: file(relativePath: { eq: "hero-evento.jpg"}) {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        allEventoYaml{
          edges{
            node{
              title
              subject
              text
              lang
            }
          }
        }    
      }
    `}
    render={data => {
      const { title, subject, text } = findLocalized(data.allEventoYaml, locale);
      return (
        <section className="section evento hero-testata">
          <Img className="evento__img" loading="eager" fluid={data.hero.childImageSharp.fluid} alt="" />
          <div className="evento__text">
            <div className="evento__title">{title}</div>
            <div className="evento__subject">{subject}</div>
            <div className="evento__desc" dangerouslySetInnerHTML={{__html: inlineLexer(text, [])}}></div>
            {/* <a onClick="trackOutboundLink('https://www.eventbrite.it/e/biglietti-intranet-italia-day-43748794823','iscriviti','partecipa');return false;" href="https://www.eventbrite.it/e/biglietti-intranet-italia-day-43748794823" title="Partecipa" className="btn-cta btn-style-2">Partecipa</a> */}
          </div>
        </section>
      )
    }}
  />
);

export default injectIntl(Evento);
